module.exports = __webpack_public_path__ + "static/img/act_text_03.ee9b712.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/doubleFestival/3/act_text_03.png
// module id = gJv+
// module chunks = 1